import service from './request'

/**
 * 获工单类别列表
 */
 export const orderTypeGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/orderType/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 添加工单类别信息
 */
 export const orderTypeAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderType/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改工单类别信息
 */
 export const orderTypeUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderType/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除工单类别信息
 */
 export const orderTypeDelInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/orderType/delInfo',
      method: 'post',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/orderTypeManagement.js